import React from 'react';

import CardHeader from './CardHeader';

import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles((theme) => ({
  cards: {
    borderRadius: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    border: '1px solid ' + theme.palette.divider,
  },
}));

export default function CardBase(props) {
  const classes = useStyles();
  return (
    <Box
      className={'promotionalcard ' + classes.cards}
      component={Card}
      position='relative'
    >
      <CardHeader
        contenttype={props.contenttype && props.contenttype}
        categories={props.categories && props.categories}
      />
      {props.children}
    </Box>
  );
}
